<div class="SLV2-prctcs-qutn-pg-wrap">

    <!-- header start -->
    <div class="SLV2-prctcsqustn-hdr">
        <div class="SLV2-prctcsqustn-hdr-title-row">
            <button class="SLV2-prctcsqustn-close-btn" (click)="quitPractice()">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
            </button>
            <h3 class="SLV2-prctcsqustn-hdr-title">{{currentQuestionNumber+1}} of {{questionsData.length}}</h3>
            <!-- <div class="SLV2-upgrade-animated-icon">
                <div id="levelDiv" class="SLV2-upgrade-count" *ngIf="!showGifIcon">
                    <span>{{revCardData?.level}}</span>
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/upgrade-shild-icon.png" class="SLV2-upgrade-shild-icon" />
                </div>
               <span *ngIf="showGifIcon"><img style="z-index: 2;" id="levelupImg" src="selflearnv2-ui/assets/img/self-learn-v2/upgrade-animated.gif" class="_opacity-0" /></span> 
            </div> -->
        </div>
        <div class="SLV2-prctcsqustn-hdr-progressbar">
            <span [style.width]="((currentQuestionNumber+1)/questionsData.length)*100 +'%'"></span>
        </div>
        
    </div>
    <!-- header ended -->

    <!-- question box start -->
    <div class="SLV2-prctcsqustn-body-wrap">
        <div class="SLV2-prctcsqustn-box">
        <!-- <div>
            <div> -->

            <div class="SLV2-questn-bx-hdr">
                <div class="SLV2-time">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/clock-green-icon.svg" /><span>{{fmtMSS(timeSpent)}}</span>
                </div>
                 
                <div>
                    <button class="SLV2-qutn-bkmrk-btn" (click)="openUserFeedbackDialog()">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/flag-black-icon.svg" />
                    </button>
                    <!-- <button class="SLV2-qutn-bkmrk-btn">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-line-icon.svg" />
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-icon.svg" hidden />
                    </button> -->
                </div>
            </div>

            <div class="SLV2-questn-bx-cont-area">
                <div class="SLV2-questn-wrap">
                <!-- 
                [ngClass]="flagData?.showSolutionBtn ? 'modal-body-sol' : 'modal-body'" -->
                    <div class="row">
                        <ng-container #questioncontainer>
                        <!-- <div #questioncontainer class="row"> -->
                            <div class="col-md-7 seperator-line">
                                <div class="card-inner-for-learn">
                                    <mat-dialog-content class="card-content-body card-content-body-overflow"
                                        >
                                        <div class="SLV2-question-text">Q{{currentQuestionNumber+1}}. </div>
                                        <div  [mathMl]="this.questionsData[this.currentQuestionNumber].questiontext"></div>
                                    </mat-dialog-content>
                                    <!-- <div class="display-415-below-none">
                                        <div class="submit-set" style="justify-content: flex-start;">
                                            <button class="btn prev-btn" [disabled]="revCardNo == 1" (click)="previousQuestion()">
                                                <img src="assets/img/selfLearn/left-arrow.svg" />
                                                <span class="prev-txt">PREVIOUS</span>
                                            </button>
                        
                                            <button [disabled]="(!(!flagData?.enableNextBtn && !flagData?.enableSkipBtn))" class="btn skip-btn"
                                                (click)="skipQuestion()">
                                                SKIP
                                            </button>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        
                            <div class="col-md-5">
                                <div class="SLV2-full-option-wrap">
                                <div class="card-inner-for-learn">
                                    <mat-card-title class="card-content-answer-title" *ngIf="!flagData?.isSolution || deviceWidth<=415">
                                        <div>Select Your Answer</div>
                                        <div class="sol-drpdwn display-415-below-none">
                                            <!-- <button *ngIf="!flagData?.isSolution && flagData?.showSolutionBtn"
                                                class="btn sol-btn align-items-center" (click)="showSolution()">
                                                <img src="assets/img/selfLearn/bulb.svg" />
                                                <span class="sol-txt">Solution</span>
                                                <span class="sol-drop-down-arrow"><img src="assets/img/selfLearn/dropdown-arrow.svg" /></span>
                                            </button> -->
                                        </div>
                                    </mat-card-title>
                        
                                    <div *ngIf="!flagData?.isSolution || deviceWidth<=415">
                                        <!-- Different question types -->
                                        <div class="exam-question-top">
                                            <div class="ASM_QP_psg_txt" *ngIf="this.questionsData[this.currentQuestionNumber]?.question_type == 'passage based question'">
                                                <div class="psg_word">
                                                    Passage
                                                </div>
                                                <div [mathMl]="this.questionsData[this.currentQuestionNumber]?.passagetext"></div>
                                            </div>
                                            <div class="question">
                                                <span class="question-no">
                                                    <!-- {{revCardData?.question_id}} -->
                                                </span>
                                                <div class="question-content">
                        
                                                    <ul *ngIf="this.questionsData[this.currentQuestionNumber]?.question_type  == 'single correct mcq' ||
                                                    this.questionsData[this.currentQuestionNumber].question_type  == 'single correct mcq (sec-a)' || 
                                                    this.questionsData[this.currentQuestionNumber].question_type  == 'matrix match single correct' ||
                                                    this.questionsData[this.currentQuestionNumber].question_type  == 'multiple correct mcq'|| 
                                                    this.questionsData[this.currentQuestionNumber].question_type  == 'passage based question' ||
                                                    this.questionsData[this.currentQuestionNumber].question_type  == 'assertion and reason' ||
                                                    this.questionsData[this.currentQuestionNumber]  == 'MMCQ'; else numericPad" class="option-list">
                                                        <li class="option" *ngFor="let qc of questionsData[this.currentQuestionNumber]?.questionchoices;index as i">
                                                            <div *ngIf="this.questionsData[this.currentQuestionNumber]?.question_type == 'MMCQ'; else MCQBlock"
                                                                class="custom-control custom-radio assessment_pl-5">
                                                                <input type="checkbox" checked id="click{{i+1}}"
                                                                    *ngIf="selectedMultiAnswer && selectedMultiAnswer[i+1]; else unselected">
                        
                                                                <ng-template #unselected>
                                                                    <input type="checkbox" id="click{{i+1}}">
                                                                </ng-template>
                                                                <label for="click{{i+1}}" class="assessment_pl-10" id="{{i+1}}"
                                                                    [mathMl]="qc?.choicetext"></label>
                                                            </div>
                                                            <ng-template #MCQBlock>
                                                                <div class="custom-control custom-radio assessment_pl-5">
                        
                                                                    <mat-radio-group *ngIf="!this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted"
                                                                        [disabled]="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted" class="example-radio-group"
                                                                        (change)="radioChange($event?.value, i+1)">
                                                                        <mat-radio-button [value]="qc"
                                                                            [checked]="this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse === (i+1).toString()"
                                                                            class="answers-set example-radio-button {{selectedData?.index === i ? 'selected': ''}}"
                                                                            >
                                                                            <div [mathMl]="qc?.choicetext" class="select-answers">
                                                                            </div>
                                                                        </mat-radio-button>
                                                                    </mat-radio-group>
                                                                    <mat-radio-group *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted"
                                                                        [disabled]="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted" class="example-radio-group">
                                                                        <mat-radio-button [value]="qc" class="example-radio-button"
                                                                            [ngClass]="{'is-correct': isCorrect(qc, i+1),'is-incorrect': isIncorrect(qc, i+1)}"
                                                                            [checked]="this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse === (i+1).toString()"
                                                                            >
                                                                            <div class="select-answers" [mathMl]="qc?.choicetext">
                                                                            </div>
                                                                        </mat-radio-button>
                                                                    </mat-radio-group>
                                                                </div>
                                                            </ng-template>
                                                        </li>
                        
                                                        <li class="option" *ngIf="currentQuestionData?.questionchoices?.length==0">
                                                            <h3>
                                                                No options
                                                            </h3>
                                                        </li>
                                                    </ul>
                                                    <ng-template #numericPad>
                                                        <!-- <ng-container *ngIf="currentQuestionData?.question_type  == 'Matrix'; else numPadUI">
                                                            <div class="ASM_matrix_qopt_grid assessment_mb-15 assessment_mt-5">
                                                                <div class="ASM_matrix_qopt_row">
                                                                    <div class="ASM_qp_matrix_qopt">
                        
                                                                    </div>
                                                                    <div class="ASM_qp_matrix_qopt" *ngFor="let letterC2 of matrixColumns[1]">
                                                                        {{letterC2}}
                                                                    </div>
                                                                </div>
                                                                <div class="ASM_matrix_qopt_row" *ngFor="let letterC1 of matrixColumns[0]">
                                                                    <div class="ASM_qp_matrix_qopt">
                                                                        {{letterC1}}
                                                                    </div>
                                                                    <div class="ASM_qp_matrix_qopt"
                                                                        [class.selected]="matrixReponses[letterC1][letterC2]"
                                                                        *ngFor="let letterC2 of matrixColumns[1]"
                                                                        (click)="matrixReponses[letterC1][letterC2] = !matrixReponses[letterC1][letterC2]">
                                                                        {{matrixReponses[letterC1][letterC2] ?
                                                                        '&#10003;': ''}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container> -->
                                                        <ng-template #numPadUI>
                                                            <!-- <div class="nPad"
                                                                [ngClass]="currentQuestionData?.question_type == 'Numeric' ? 'ASM_decimal-pad': 'ASM_int-pad'">
                                                                <div class="pad-input">
                                                                    {{selectedAnswerr?.length ? selectedAnswerr[0]: ""
                                                                    }}
                                                                </div>
                        
                                                                <button class="pad-btn" [class.selected]="selectedNPadBtnText == num"
                                                                    *ngFor="let num of numPadDigits1To9">
                                                                    {{num}}
                                                                </button>
                        
                                                                <div class="pad-btn ASM_pad-btn-period"
                                                                    [class.selected]="selectedNPadBtnText == '.'"
                                                                    (click)="padBtnClick($event, '.')">
                                                                    .
                                                                </div>
                                                                <div class="pad-btn ASM_pad-btn-0" [class.selected]="selectedNPadBtnText == '0'"
                                                                    (click)="padBtnClick($event, 0)">
                                                                    0
                                                                </div>
                                                                <div class="pad-btn ASM_pad-btn--" [class.selected]="selectedNPadBtnText == '-'"
                                                                    (click)="padBtnClick($event, '-')">
                                                                    -
                                                                </div>
                                                                <div class="pad-btn pad-clear-btn" (click)="padBtnClick($event, 'clear')">
                                                                    Clear
                                                                </div>
                                                            </div> -->
                                                        </ng-template>
                        
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                        
                                        <!-- Different question types -->

                                        <div class="SLV2-solution-btn-wrap solution-button-desk-view" *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted">
                                            <ng-container *ngTemplateOutlet="solutionButtonTemplate"></ng-container>
                                        </div>
                                    </div>
                                
                                    
                                    
                                    <!-- <div class="display-415-below">
                                        <div class="submit-set">
                                            <button *ngIf="!flagData?.enableNextBtn && !flagData?.enableSkipBtn"
                                                [disabled]="!flagData?.isSelected"
                                                [ngClass]="flagData?.isSelected ? 'common-button': 'common-button disable-btn'"
                                                (click)="submitSelectedQuestion()">SUBMIT</button>
                                            <button *ngIf="flagData?.enableNextBtn && revCardNo <= questionsData?.length - 1"
                                                class="common-button" (click)="nextQuestion()">NEXT</button>
                                            <button
                                                *ngIf="revCardData?.level <= 4 && !(!flagData?.enableNextBtn && !flagData?.enableSkipBtn) && checkPracticeQuestionCompletedOrNot() && questionSubmitMessage == 'QuestionNotAvailable' && revCardNo == questionsData?.length"
                                                class="common-button" (click)="submitEntireLearningFlashDeck()">DONE</button>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="SLV2-solution-desk-view">
                                <ng-container *ngTemplateOutlet="solutionTemplate"></ng-container>
                                </div>
                                </div>
                            </div>
                        <!-- </div> -->
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="SLV2-questn-actn-area">

                <div class="solution-button-sm-device-view" *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted && !flagData?.isSolution">
                    <ng-container *ngTemplateOutlet="solutionButtonTemplate"></ng-container>
                </div>

                <button class="SLV2-questn-text-btn prev-btn" *ngIf="currentQuestionNumber != 0" [disabled]="currentQuestionNumber == 0" (click)="previousQuestion()">Previous</button>

                <button *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse =='null'" class="SLV2-questn-solid-btn skip-btn" (click)="skipQuestion()">Skip</button>

                <button *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse !='null' && !this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted" [ngClass]="this.questionsData[this.currentQuestionNumber].questionInfo.questionResponse !='null' && !this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted ? 'SLV2-questn-solid-btn': 'SLV2-questn-solid-btn disable-btn'" (click)="submitSelectedQuestion()">Submit</button>
                <button *ngIf="this.questionsData[this.currentQuestionNumber].questionInfo.isSubmitted" class="SLV2-questn-solid-btn" (click)="nextQuestion()" >Next</button>
                <!-- <button id="doneBtn" *ngIf="currentQuestionNumber?.level <= 4 && !(!flagData?.enableNextBtn && !flagData?.enableSkipBtn) && checkPracticeQuestionCompletedOrNot() && revCardNo == questionsData?.length"
                    class="SLV2-questn-solid-btn" (click)="submitEntireLearningFlashDeck()">Done</button> -->
            </div>


            <div class="SLV2-solution-mobile-view">
                <ng-container *ngTemplateOutlet="solutionTemplate"></ng-container>
            </div>

        </div>
    </div>
    <!-- question box ended -->


    

</div>

<ng-template #solutionButtonTemplate>
    <!-- *ngIf="!flagData?.isSolution && flagData?.showSolutionBtn" -->
    <button class="SLV2-solution-btn" (click)="showSolution()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/lightbulb-icon.svg" /> <span class="sol-txt">Solution</span>
        <!-- <span class="sol-drop-down-arrow"><img src="assets/img/selfLearn/dropdown-arrow.svg" /></span> -->
    </button>
</ng-template>

<ng-template #solutionTemplate>
    <div class="solution-box _display-415-below-none" *ngIf="flagData?.isSolution">
        <div class="solution-box-set">
            <div class="solution-hdr-lft-col">
                <button class="solution-back-btn" (click)="flagData.isSolution = false"><img
                        src="selflearnv2-ui/assets/img/self-learn-v2/left-gray-arrow.svg" /></button>
                <span class="solution-hdng"><img src="selflearnv2-ui/assets/img/self-learn-v2/lightbulb-icon.svg" />Solution</span>
                <span class="solution-dificult-type">(Easy)</span>
            </div>
    
            <!-- <div class="close-icon" (click)="flagData.isSolution = false">
                                                    <img src="assets/img/selfLearn/close-icon.svg" />
                                                </div> -->
        </div>
        <mat-card-content class="sol-content card-content-body" >
            <div class="SLV2-play-blue-bg-icon" (click)="redirectToVideoPage()" *ngIf="currentQuestionData?.Video_SolutionID!=''">
                <div class="play-btn-icon">
                    <img  src="selflearnv2-ui/assets/img/self-learn-v2/play-white-btn-icon.svg" />
                </div>
                <img class="SLV2-thumbnail-img" [src]=" this.questionsData[this.currentQuestionNumber]?.video_solution_data?.thumbnail" height ="196px" width="350px" alt=""> 
             </div>
            <div [mathMl]="currentQuestionData?.view_solution[0].data"></div>
        </mat-card-content>
        <!-- <span class="solution-attempts">
                                                                <span *ngIf="revCardData?.numofattempts">
                                                                <img src="assets/img/selfLearn/attempts.svg" />
                                                                {{revCardData?.numofattempts}} attempts</span>
                                                                <span style="padding-left: 25px;" *ngIf="revCardData?.percentageright"><img
                                                                        src="assets/img/selfLearn/tick.svg" />
                                                                    {{revCardData?.percentageright}}% got this right</span>
                                                            </span> -->
        <!-- <ng-container *ngTemplateOutlet="UNFAPP_playcard"></ng-container> 
                                                            
                                                            <ng-container *ngTemplateOutlet="solution_attempts"></ng-container> -->
        <!-- <div (click)="redirectToVideoPage()">
                                                                {{revCardData?.question?.video_solution_data?.title}}
                                                            <img [src]="revCardData?.question?.video_solution_data?.thumbnail" height ="150" width="150"alt=""> 
                                                            </div> -->
        <!-- (click)="submitSelectedQuestion()" -->
        <!-- <div class="SLV2-play-user-actn-row">
            <h1 class="helpful-text">Was this helpful?</h1>
            <div class="SLV2-user-btn-box">
                <button class="SLV2-user-btn dislike-btn">
                    <div class="SLV2-btn-icon" [ngClass]="{'active':userDislikeStatus}" (click)="userDislike()">
                        <img *ngIf="!userDislikeStatus" src="selflearnv2-ui/assets/img/self-learn-v2/dislike-icon.svg" class="like-img" />
                        <img *ngIf="userDislikeStatus" src="selflearnv2-ui/assets/img/self-learn-v2/dislike-fill-icon.svg" class="like-img" />
                    </div>
                </button>
                <button class="SLV2-user-btn like-btn">
                    <div class="SLV2-btn-icon" [ngClass]="{'active':userLikeStatus}" (click)="userLike()">
                        <img *ngIf="!userLikeStatus" src="selflearnv2-ui/assets/img/self-learn-v2/like-icon.svg" class="like-img" />
                        <img *ngIf="userLikeStatus" src="selflearnv2-ui/assets/img/self-learn-v2/like-fill-icon.svg" class="like-img" />
                    </div>
                </button>
            </div>
        </div> -->
    </div>
</ng-template>